import { render, staticRenderFns } from "./opr_agency_user.vue?vue&type=template&id=12f810d8&"
import script from "./opr_agency_user.vue?vue&type=script&lang=js&"
export * from "./opr_agency_user.vue?vue&type=script&lang=js&"
import style0 from "./opr_agency_user.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports